import PayoutInformationSimpleView from './PayoutInformationSimpleView'

export default PayoutInformationSimpleView
